import SolidChevronLeftIcon from 'heroicons/solid/chevron-left.svg'
import SolidPencilAltIcon from 'heroicons/solid/pencil-alt.svg'
import SolidPLusCircleIcon from 'heroicons/solid/plus-circle.svg'
import SolidMinusCircleIcon from 'heroicons/solid/minus-circle.svg'
import SolidUserAddIcon from 'heroicons/solid/user-add.svg'
import SolidXIcon from 'heroicons/solid/x.svg'
import SolidXCircleIcon from 'heroicons/solid/x-circle.svg'
import SolidExclamationIcon from 'heroicons/solid/exclamation.svg'
import SolidForwardToInboxIcon from '@/assets/forward_to_inbox.svg'
import SolidFolderOpenIcon from 'heroicons/solid/folder-open.svg'
import SolidXCheckCircleIcon from 'heroicons/solid/check-circle.svg'


const solid = {
  SolidChevronLeftIcon,
  SolidPencilAltIcon,
  SolidPLusCircleIcon,
  SolidMinusCircleIcon,
  SolidUserAddIcon,
  SolidXIcon,
  SolidXCircleIcon,
  SolidExclamationIcon,
  SolidForwardToInboxIcon,
  SolidFolderOpenIcon,
  SolidXCheckCircleIcon,
}
import OutlineChevronDownIcon from 'heroicons/outline/chevron-down.svg'
import OutlineChevronUpIcon from 'heroicons/outline/chevron-up.svg'
import OutlinePLusCircleIcon from 'heroicons/outline/plus-circle.svg'
import OutlineXCircleIcon from 'heroicons/outline/x-circle.svg'
import OutlinePencilAltIcon from 'heroicons/outline/pencil-alt.svg'
import OutlineInformationCircleIcon from 'heroicons/outline/information-circle.svg'
import OutlineAdjustmentsIcon from 'heroicons/outline/adjustments.svg'
import OutlineExclamationIcon from 'heroicons/outline/exclamation.svg'
import OutlineCollectionIcon from 'heroicons/outline/collection.svg'
import OutlineCheckCircleIcon from 'heroicons/outline/check-circle.svg'
import OutlineGmailIcon from './gmail.svg'
import OutlineDownloadIcon from 'heroicons/outline/download.svg'
import OutlineClipboardCheckIcon from 'heroicons/outline/clipboard-check.svg'
import OutlinExternalLinkIcon from 'heroicons/outline/external-link.svg'
import OutlineLibraryIcon from 'heroicons/outline/library.svg'
import OutlineClockIcon from 'heroicons/outline/clock.svg'
import OutlineUserIcon from 'heroicons/outline/user.svg'

import OutlinePresentIcon from '@/assets/present.svg'

const outline = {
  OutlineChevronDownIcon,
  OutlineChevronUpIcon,
  OutlinePLusCircleIcon,
  OutlineXCircleIcon,
  OutlinePencilAltIcon,
  OutlineInformationCircleIcon,
  OutlineAdjustmentsIcon,
  OutlineExclamationIcon,
  OutlineCollectionIcon,
  OutlineCheckCircleIcon,
  OutlineGmailIcon,
  OutlineDownloadIcon,
  OutlineClipboardCheckIcon,
  OutlinExternalLinkIcon,
  OutlineLibraryIcon,
  OutlineClockIcon,
  OutlineUserIcon,
  OutlinePresentIcon
}

import FirmaDigitalTokenIcon from './firma-digital-con-token.svg'
import FirmaDigitalRemotaIcon from './firma-digital-remota.svg'

const custom = {
  FirmaDigitalTokenIcon,
  FirmaDigitalRemotaIcon,
}

const icons = {
  ...solid,
  ...outline,
  ...custom,
}

export default icons
